export interface ProjectPermissions {
    rootSubjectCreate: boolean;
}
